module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "help"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    style: (_vm.helpImgCss)
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "help-bg1 clear-fix"
  }, [_c('div', {
    staticClass: "wh1200"
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "help-wp1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "http://wpa.qq.com/msgrd?v=3&uin=2850559846&site=qq&menu=yes",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-qq"
  })])]), _vm._v(" "), _c('h3', [_vm._v("在线客服")]), _vm._v(" "), _c('p', [_vm._v("工作时间：8:30-18:00")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "help-wp1"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-phone"
  })]), _vm._v(" "), _c('h3', [_vm._v("0755-82405890")]), _vm._v(" "), _c('p', [_vm._v("工作时间：8:30-18:00")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "help-wp1"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-commenting"
  })]), _vm._v(" "), _c('h3', [_vm._v("问答专区")]), _vm._v(" "), _c('p', [_vm._v("小森为您解答")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "help-bg2 clear-fix"
  }, [_c('div', {
    staticClass: "wh1200"
  }, [_c('div', {
    staticClass: "help-title1"
  }, [_c('span', [_vm._v("大家经常搜的")])]), _vm._v(" "), _c('ul', {
    staticClass: "clear-fix help-ul1"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/委托业务简介"
    }
  }, [_vm._v("委托业务简介")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/租赁收入列表"
    }
  }, [_vm._v("租赁收入列表")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/租赁业务简介"
    }
  }, [_vm._v("租赁业务简介")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/委托库查询"
    }
  }, [_vm._v("委托库查询")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/维修业务简介"
    }
  }, [_vm._v("维修业务简介")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/维修价格查询"
    }
  }, [_vm._v("维修价格查询")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/物流订单管理"
    }
  }, [_vm._v("物流订单管理")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/发货通知单"
    }
  }, [_vm._v("发货通知单")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/采购询价单"
    }
  }, [_vm._v("采购询价单")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/账户管理"
    }
  }, [_vm._v("账户管理")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "help-wp2"
  }, [_c('el-input', {
    attrs: {
      "placeholder": "试试搜索关键词"
    },
    model: {
      value: (_vm.helpKeyWords),
      callback: function($$v) {
        _vm.helpKeyWords = $$v
      },
      expression: "helpKeyWords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toHelpList($event)
      }
    },
    slot: "append"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "help-bg3 clear-fix"
  }, [_c('div', {
    staticClass: "wh1200"
  }, [_c('div', {
    staticClass: "help-title1 help-title2"
  }, [_c('span', [_vm._v("热门问题")])]), _vm._v(" "), _c('div', {
    staticClass: "help-wp3 clear-fix"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "help-ask-wp"
  }, [_c('div', {
    staticClass: "help-ask-q"
  }, [_c('span', [_vm._v("问")]), _vm._v("合作库为用户提供哪些有价值的服务？")]), _vm._v(" "), _c('div', {
    staticClass: "help-ask-a"
  }, [_c('span', [_vm._v("答")]), _vm._v("合作库供应链平台为用户提供管家式的服务与适时信息查询（询价、下单、委托、租赁、维修、物流、售后、结算），目地是按帮助用户让业务、运营、管理变得简单、高效、便捷、透明、可控。")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "help-ask-wp"
  }, [_c('div', {
    staticClass: "help-ask-q"
  }, [_c('span', [_vm._v("问")]), _vm._v("合作库如何保证用户信息安全？")]), _vm._v(" "), _c('div', {
    staticClass: "help-ask-a"
  }, [_c('span', [_vm._v("答")]), _vm._v("合作库网站与数据库分别部署在不同的服务器上，访问权限受到严格控制。云端服务器24小时检测健康状态，且能随时调整服务器配置，保障用户数据安全。")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "help-ask-wp"
  }, [_c('div', {
    staticClass: "help-ask-q"
  }, [_c('span', [_vm._v("问")]), _vm._v("我需要的产品在合作库怎么查不到？")]), _vm._v(" "), _c('div', {
    staticClass: "help-ask-a"
  }, [_c('span', [_vm._v("答")]), _vm._v("1.选择快速上传您的产品需求给我们；"), _c('br'), _vm._v("2.直接在线咨询客服人员。")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "help-ask-wp"
  }, [_c('div', {
    staticClass: "help-ask-q"
  }, [_c('span', [_vm._v("问")]), _vm._v("为什么查不到采购、委托销售/租赁的价格？")]), _vm._v(" "), _c('div', {
    staticClass: "help-ask-a"
  }, [_c('span', [_vm._v("答")]), _vm._v("采购、销售/租赁价格：因行业价格变化波动频率大，为保证价格和货源的准确性，我们采取的方式是适时回复处理。")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "help-ask-wp"
  }, [_c('div', {
    staticClass: "help-ask-q"
  }, [_c('span', [_vm._v("问")]), _vm._v("配件租赁相比传统采购的成本优势在哪里？")]), _vm._v(" "), _c('div', {
    staticClass: "help-ask-a"
  }, [_c('span', [_vm._v("答")]), _vm._v("租赁配件可根据实际运营需求调整，相比传统采购在资金投入、库存、运营管理…..整体能帮助用户减少5%或以上的运营成本。")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "help-ask-wp"
  }, [_c('div', {
    staticClass: "help-ask-q"
  }, [_c('span', [_vm._v("问")]), _vm._v("用户有配件需要加入委托销售/租赁需要支付哪些收费？")]), _vm._v(" "), _c('div', {
    staticClass: "help-ask-a"
  }, [_c('span', [_vm._v("答")]), _vm._v("目前加入委托库都是免费的，用户暂只须支付单次物流费用。平台承担仓储管理、销售运营所产生的费用。")])])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "help-bg2 clear-fix"
  }, [_c('div', {
    staticClass: "wh1200"
  }, [_c('div', {
    staticClass: "help-title1"
  }, [_c('span', [_vm._v("问题分类")])]), _vm._v(" "), _c('div', {
    staticClass: "help-wp4 clear-fix"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "text-center help-wp4-ul"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/help_icon1.png"),
      "alt": "委托管理"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "help-ul2"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/委托管理"
    }
  }, [_vm._v("委托管理")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/委托业务简介"
    }
  }, [_vm._v("委托业务简介")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/委托订单列表"
    }
  }, [_vm._v("委托订单列表")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/租赁收入列表"
    }
  }, [_vm._v("租赁收入列表")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/出售收入列表"
    }
  }, [_vm._v("出售收入列表")])], 1)])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "text-center help-wp4-ul"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/help_icon2.png"),
      "alt": "租赁管理"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "help-ul2"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/租赁管理"
    }
  }, [_vm._v("租赁管理")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/租赁业务简介"
    }
  }, [_vm._v("租赁业务简介")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/租赁订单查询"
    }
  }, [_vm._v("租赁订单查询")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/租赁价格查询"
    }
  }, [_vm._v("租赁价格查询")])], 1)])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "text-center help-wp4-ul"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/help_icon3.png"),
      "alt": "库存查询"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "help-ul2"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/库存查询"
    }
  }, [_vm._v("库存查询")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/委托库查询"
    }
  }, [_vm._v("委托库查询")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/代管库查询"
    }
  }, [_vm._v("代管库查询")])], 1)])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "text-center help-wp4-ul"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/help_icon4.png"),
      "alt": "维修查询"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "help-ul2"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/维修查询"
    }
  }, [_vm._v("维修查询")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/维修业务简介"
    }
  }, [_vm._v("维修业务简介")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/维修下单列表"
    }
  }, [_vm._v("维修下单列表")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/维修价格查询"
    }
  }, [_vm._v("维修价格查询")])], 1)])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "text-center help-wp4-ul"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/help_icon5.png"),
      "alt": "物流信息查询"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "help-ul2"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/物流信息查询"
    }
  }, [_vm._v("物流信息查询")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/发货单管理"
    }
  }, [_vm._v("发货单管理")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/物流订单管理"
    }
  }, [_vm._v("物流订单管理")])], 1)])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "text-center help-wp4-ul"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/help_icon6.png"),
      "alt": "财务查询"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "help-ul2"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/财务查询"
    }
  }, [_vm._v("财务查询")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/委托收入报表"
    }
  }, [_vm._v("委托收入报表")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/委托销售报表"
    }
  }, [_vm._v("委托销售报表")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/维修支出报表"
    }
  }, [_vm._v("维修支出报表")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/物流支出报表"
    }
  }, [_vm._v("物流支出报表")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/保证金报表"
    }
  }, [_vm._v("保证金报表")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/代管库支出报表"
    }
  }, [_vm._v("代管库支出报表")])], 1)])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "text-center help-wp4-ul"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/help_icon7.png"),
      "alt": "订单管理"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "help-ul2"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/订单管理"
    }
  }, [_vm._v("订单管理")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/发货通知单"
    }
  }, [_vm._v("发货通知单")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/采购询价单"
    }
  }, [_vm._v("采购询价单")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/委托申请单"
    }
  }, [_vm._v("委托申请单")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/调度申请单"
    }
  }, [_vm._v("调度申请单")])], 1)])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "text-center help-wp4-ul"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/help_icon8.png"),
      "alt": "个人中心"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "help-ul2"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/个人中心"
    }
  }, [_vm._v("个人中心")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/公司信息"
    }
  }, [_vm._v("公司信息")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/服务网点维护"
    }
  }, [_vm._v("服务网点维护")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/工程师信息维护"
    }
  }, [_vm._v("工程师信息维护")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/helpList/在线反馈"
    }
  }, [_vm._v("在线反馈")])], 1)])])])], 1)], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23a48018"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Help.vue
// module id = 707
// module chunks = 0